(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["careers_half-slideshow"] && !Shopify.designMode) return;
  try {
    
const swiperUgc = new Swiper('.swiper.half-slideshow', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  },
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cta-banner"] && !Shopify.designMode) return;
  try {
    
const swiperTestimon = new Swiper('.swiper.cta-banner', {  
  direction: 'horizontal',
  breakpoints: {
    0: {
      slidesPerView: 3,
      loop: false,
      autoplay: {
        enabled: false,
        delay: 3000,
        disableOnInteraction: false,
      },
    },
    749: {
      slidesPerView: 3,
    },
  },                    
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["easter-egg"]) return;
  try {
    
document.getElementById('NewsletterForm--easter-egg').addEventListener('click', e => {
  const tgt = e.target;
  document.querySelector('.screen_two .checkbox-wrapper').classList.add('display-items')
});

document.addEventListener('click', function (event) {

  // If the clicked element doesn't have the right selector, bail
  if (!event.target.matches('.join-btn')) return;

  // Log the clicked element in the console
  console.log(event.target);
  
  var checkboxes = document.querySelectorAll(".screen_two .checkbox");      
  
  for(var i = 0; i < checkboxes.length; i++){
     var parent = checkboxes[i].closest('label');
    
     if (checkboxes[i].checked) {
       parent.classList.remove('error-found');
     } else {
       parent.classList.add('error-found');
     }
  }
}, false);

document.getElementById('easterSubscribe').addEventListener('click', e => {
  const button = document.getElementById('easterSubscribe');

  const isActive = button.classList.contains("field__button");

  console.log(isActive);
  
});

const footercheckboxes = [...document.querySelectorAll('.screen_two .footer__newsletter .checkbox-wrapper input[type=checkbox]')]
function anyChecked() {    
  return footercheckboxes.every(x=>x.checked)
}
footercheckboxes.forEach(checkbox => {
  checkbox.addEventListener('click', () => {
    anyChecked()
      ? easterSubscribe.removeAttribute('disabled')
      : easterSubscribe.setAttribute('disabled','')
  })
})
anyChecked()
    ? easterSubscribe.removeAttribute('disabled')
    : easterSubscribe.setAttribute('disabled','')


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["events-blog"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    var endlessScroll = new Ajaxinate();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  const headers = document.getElementsByClassName("menu-trigger"),
        contents = document.getElementsByClassName("content"),
        icons = document.getElementsByClassName("icon-toggle");

  for (let i = 0; i < headers.length; i++) {
      headers[i].addEventListener("click", () => {
          for (let j = 0; j < contents.length; j++) {
              if (i == j) {
                  icons[j].innerHTML = contents[j].getBoundingClientRect().height === 0 ? "-" : "+";
                  contents[j].classList.toggle("content-transition");
              } else {
                  icons[j].innerHTML = "+";
                  contents[j].classList.remove("content-transition");
              }
          }

      });
  }

  document.getElementById('NewsletterForm--footer').addEventListener('click', e => {
    const tgt = e.target;
    document.querySelector('footer .checkbox-wrapper').classList.add('display-items')
  });

  document.addEventListener('click', function (event) {

    // If the clicked element doesn't have the right selector, bail
    if (!event.target.matches('.join-btn')) return;

    // Log the clicked element in the console
    console.log(event.target);
    
    var checkboxes = document.getElementsByClassName("checkbox");
      
    
    for(var i = 0; i < checkboxes.length; i++){
       var parent = checkboxes[i].closest('label');
      
       if (checkboxes[i].checked) {
         parent.classList.remove('error-found');
       } else {
         parent.classList.add('error-found');
       }
    }
  }, false);

  document.getElementById('Subscribe').addEventListener('click', e => {
    const button = document.getElementById('Subscribe');

    const isActive = button.classList.contains("field__button");

    console.log(isActive);
    
    // let checks = document.querySelectorAll('footer .checkbox-wrapper input[type=checkbox]');
    // checks.forEach((el) => {
    //   el.classList.add('gold');
    // });
  });

  const footercheckboxes = [...document.querySelectorAll('footer .footer__newsletter .checkbox-wrapper input[type=checkbox]')]
  function anyChecked() {    
    return footercheckboxes.every(x=>x.checked)
  }
  footercheckboxes.forEach(checkbox => {
    checkbox.addEventListener('click', () => {
      anyChecked()
        ? Subscribe.removeAttribute('disabled')
        : Subscribe.setAttribute('disabled','')
    })
  })
  anyChecked()
      ? Subscribe.removeAttribute('disabled')
      : Subscribe.setAttribute('disabled','')


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["info-banner"] && !Shopify.designMode) return;
  try {
    
const swiperTestimon = new Swiper('.swiper.info-banner', {  
  direction: 'horizontal',
  breakpoints: {
    0: {
      slidesPerView: 1,
      loop: true,
      autoplay: {
        enabled: true,
        delay: 3000,
        disableOnInteraction: false,
      },
    },
    749: {
      slidesPerView: 3,
    },
  },                    
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    var endlessScroll = new Ajaxinate();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    var endlessScroll = new Ajaxinate();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story_info-banner-sticky"] && !Shopify.designMode) return;
  try {
    
const swiperTestimon = new Swiper('.swiper.info-banner', {  
  direction: 'horizontal',
  breakpoints: {
    0: {
      slidesPerView: 1,
      loop: true,
      autoplay: {
        enabled: true,
        delay: 3000,
        disableOnInteraction: false,
      },
    },
    749: {
      slidesPerView: 1,
    },
  },                    
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story_info-banner"] && !Shopify.designMode) return;
  try {
    
const swiperTestimon = new Swiper('.swiper.info-banner', {  
  direction: 'horizontal',
  breakpoints: {
    0: {
      slidesPerView: 1,
      loop: true,
      autoplay: {
        enabled: true,
        delay: 3000,
        disableOnInteraction: false,
      },
    },
    749: {
      slidesPerView: 1,
    },
  },                    
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our_beer-vertical-swiper"] && !Shopify.designMode) return;
  try {
    

  const fadeText = new Swiper('.swiper.fade-text', {  
    direction: 'vertical',  
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 1000,
    mousewheel: {
      forceToAxis: true,
      sensitivity: 0.5,
      releaseOnEdges: true,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    loop: false, 
  });

  const swipeImage = new Swiper('.swiper.swipe-image', {  
    direction: 'vertical',
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 1000,
    mousewheel: {
      forceToAxis: true,
      sensitivity: 0.5,
      releaseOnEdges: true,
    },
    effect: "slide",
    loop: false, 
  });

  
  fadeText.controller.control = swipeImage;
  swipeImage.controller.control = fadeText;
  
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pub-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-pub-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    // closeSearchModal() {
      // this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      // this.searchModal.close(false);
    // }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
const swiperTestimon = new Swiper('.swiper.testimonials', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  // And if we need scrollbar
  scrollbar: {
    el: '.swiper-scrollbar',
  },
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-reviews"] && !Shopify.designMode) return;
  try {
    
const swiperUgc = new Swiper('.swiper.ugc', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  // And if we need scrollbar
  scrollbar: {
    el: '.swiper-scrollbar',
  },
});

  } catch(e) { console.error(e); }
})();
})();
